import { StyledModalOverlay } from '@Screens/AccountManagement/components/SharedStyles';
import AccountManagementPage from '@Screens/AccountManagement/index';
import { observer } from 'mobx-react-lite';
import type { FC } from 'react';
import React from 'react';

import { useAccountManagementStore } from '~stores/account-management';

const AddNewAddressOverlay: FC = () => {
  const { uiAccountManagementPanelOpen } = useAccountManagementStore();

  if (!uiAccountManagementPanelOpen) {
    return null;
  }

  return (
    <StyledModalOverlay>
      <AccountManagementPage />
    </StyledModalOverlay>
  );
};

export default observer(AddNewAddressOverlay);
